<template>
	<div>
		<topbar></topbar>
		<sortHeader></sortHeader>
		<heardernav></heardernav>
		<div class="border p20 container_outer">
			<div class="box-h4">
				<h4 class="left">Shipping address</h4>
			</div>
			<div class="clr"></div>
			<div class="mt20">
				<form>
					<table class="table-c-5" width="100%" border="0" cellspacing="0" cellpadding="0">
						<tbody>
							<tr>
								<th style="width:150px;height:35px; background:#f60; text-align:center;">
									<p style="color:#FFf;">{{addressTitle}}</p>
								</th>
								<td></td>
							</tr>
							<tr id="areaInfo">
								<th style="width:150px;padding-right: 15px;">Area<span style="color:#f00;">*</span></th>
								<td>
									<v-distpicker @selected="onSelected" :province="select.province" :city="select.city" :area="select.district"></v-distpicker>
								</td>
							</tr>
							<tr>
								<th style="width:150px;padding-right: 15px;">Address<span style="color:#f00;">*</span></th>
								<td>
									<textarea v-model="address" rows="5" cols="55" style="width:450px; padding:5px; background:#fff; border:1px solid #c6c6c6; max-width:450px;" maxlength="50"></textarea>
								</td>
							</tr>
							<tr>
								<th style="width:150px;padding-right: 15px;">Recipient's name<span style="color:#f00;">*</span></th>
								<td>
									<input v-model="contextName" value="" type="text" style=" padding:5px; background:#fff; border:1px solid #c6c6c6; width:300px;" maxlength="10">
								</td>
							</tr>
							<tr>
								<th style="width:150px;padding-right: 15px;">Contact number<span style="color:#f00;">*</span></th>
								<td>
									<input v-model="mobile" type="text" value="" style=" padding:5px; background:#fff; border:1px solid #c6c6c6; width:185px;" maxlength="13">
									<br>
								</td>
							</tr>
							<tr>
								<th style="width:150px;padding-right: 15px;">Postal code<span style="color:#f00;">*</span></th>
								<td>
									<input v-model="zipcode" type="text" value="" style=" padding:5px; background:#fff; border:1px solid #c6c6c6; width:185px;" maxlength="13">
									<br>
								</td>
							</tr>
							<tr>
								<th style="width:150px;padding-right: 15px;"></th>
								<td>
									<input type="button" @click="saveAddress()" value="Save" class="submit_button">
								</td>
							</tr>
						</tbody>
					</table>
				</form>
				
			</div>
		</div>
		<footermenu></footermenu>
		<footercopyright></footercopyright>
	</div>
</template>
<script>
	//import jQuery from "../../../static/js/jquery.min.js"
	import jQuery from 'jquery';
	import API from "../../../static/api/api.js"
	import {parseResult} from "../../../static/js/emallUtils.js"
	import alertConfirm from "../../../static/js/alertConfirm.js"
	import Vue from 'vue'
	import TopBar from '@/components/TopBar'
	import Header from '@/components/Header'
	import FooterMenu from '@/components/FooterMenu'
	import FooterCopyright from '@/components/FooterCopyright'
	import HearderNav from '@/components/HearderNav'
	import VueClipboard from 'vue-clipboard2'
 	Vue.use(VueClipboard)
 	
 	import Distpicker from 'v-distpicker'
 	Vue.component('v-distpicker', Distpicker)
 	

    export default {
    	name: 'addressManager',
        data(){
            return {
            	goodsCode:'',
            	goodsCodes:'',
            	payNum:'',
            	select: { province: '', city: '', district: '' },
            	address:'',
            	mobile:'',
            	zipcode:'',
            	contextName:'',
            	user_area:'',
            	isEdit:'',
            	id:'',
            	addressTitle:'Add address',
            	sourceUrl:'',
            	cityInfo: '',
            	backUrl:'address_list',
            	orderSource:'',
            	boList: [],
            	distributeAccount:'',
				distributeName:'',
				shopCode:''
            }
        },
        components: {
        	'topbar':TopBar,
        	'sortHeader':Header,
	        'footermenu':FooterMenu,
			'footercopyright':FooterCopyright,
			'heardernav':HearderNav
        },
        methods:{
        	// 城市选择
	        onSelected: function (data) {
	         	this.select.province = data.province.value;
				this.select.city = data.city.value;
				this.select.district = data.area.value;
	        },
        	jump_to:function(url){
        		if(this.goodsCode != ''&&this.payNum != ''){
        			this.$router.push({ name: url, params:{
        				goodsCode:this.goodsCode,
        				payNum:this.payNum,
        				sourceUrl:this.sourceUrl
        			}});
        		}else if(this.goodsCodes != ''){
        			this.$router.push({ name: url, params:{
        				goodsCodes:this.goodsCodes
        			}});
        		}else{
        			this.$router.push({ name: url});
        		}
        	},
        	getOneAddress:function(addressId){
        		var that = this;
        		API.getOneAddress(addressId,function(ret){
        			var addressBo = ret.data;
        			if(addressBo != undefined){
        				that.contextName = addressBo.contextName;
        				that.mobile = addressBo.mobile;
        				that.address = addressBo.address;
        				
        				that.select.province = addressBo.province;
        				that.select.city = addressBo.city;
        				that.select.district = addressBo.district;
        				that.user_area = addressBo.province + ","+addressBo.city + ","+addressBo.district;
        				that.id = addressBo.id;
        				that.zipcode = addressBo.zipcode;
        				that.isEdit = "update";
        				that.addressTitle = "Change address";
        			}
        		});
        	},
        	saveAddress:function(){
        			var that = this;
        			var province = that.select.province;
					var city = that.select.city;
					var district = that.select.district;
					var address = that.address;
					var mobile = that.mobile;
					var contextName = that.contextName;
					var isEdit = that.isEdit;
					var zipcode = that.zipcode;
					var id = that.id;
					var isMobile=/^(((13[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/; //手机
					var isPhone=/^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/;   //座机
					var isZip = /^[0-9][0-9]{5}$/;
					
					if (this.isBlank(province) || this.isBlank(city) || this.isBlank(district) || this.isBlank(address) || this.isBlank(mobile) || this.isBlank(contextName)) {
						alertConfirm.singleConfirm("Incomplete information!");
					} else if(address.length<=5 || address.length>100){
						alertConfirm.singleConfirm("Address length is too long or too short!");
					} else if(!isMobile.test(mobile) && !isPhone.test(mobile)){
						alertConfirm.singleConfirm("Please fill in the correct contact number!");
					} else if(!isZip.test(zipcode)){
						alertConfirm.singleConfirm("Please fill in the correct postal code!");
					}

						else {
						province = encodeURI(province);
						city = encodeURI(city);
						district = encodeURI(district);
						address = encodeURI(address);
						contextName = encodeURI(contextName);
						
						API.saveAddress(province,city,district,address,mobile,contextName,isEdit,id,zipcode,function(ret){
							if(ret.code == 'success'){
								if(that.backUrl=='address_list'){
									that.$router.push({
									path: that.backUrl, 
									query:{
										
									}});
								}else{
									if(that.orderSource=='cart'){
										that.$router.push({
										path: that.backUrl, 
										query:{
											orderSource:that.orderSource,
											bos:that.boList,
										}});
									}else{
										that.$router.push({
										path: that.backUrl, 
										query:{
											goodsCode:that.goodsCode,
											shopCode:that.shopCode,
											payNum:that.payNum,
											orderSource:that.orderSource,
											distributeAccount:that.distributeAccount,
											distributeName:that.distributeName,
											bos:that.boList,
										}});
									}
								}
								
							}else{
								alertConfirm.singleConfirm(ret.msg);
							}
						});
					}
       		 },
        	 
        	 isBlank:function(obj){
        			return(typeof(obj)=='undefined'||obj==''||obj==null);  
        	 }
        },
        beforeMount:function(){
        	var backUrl = this.$route.query.backUrl;
        	if(backUrl != undefined){
        		this.backUrl = backUrl;
        	}
        	var boList = this.$route.query.boList;
        	if(boList != undefined){
        		this.boList = boList;
        	}
        	if(this.$route.query.orderSource != undefined){
        		this.orderSource = this.$route.query.orderSource;
        	}  
        	if(this.$route.query.goodsCode != undefined){
        		this.goodsCode = this.$route.query.goodsCode;
        	}
        	if(this.$route.query.shopCode != undefined){
        		this.shopCode = this.$route.query.shopCode;
        	}
        	if(this.$route.query.payNum != undefined){
        		this.payNum = this.$route.query.payNum;
        	}
        	//if(this.$route.query.distributeAccount != undefined){
        	//	this.distributeAccount = this.$route.query.distributeAccount;
        	//}
        	//if(this.$route.query.distributeName != undefined){
        	//	this.distributeName = this.$route.query.distributeName;
        	//}
        	var addressId = this.$route.query.addressId;
        	if(addressId != undefined){
        		this.id = addressId;
        	}
        },
		mounted(){
			window.scrollTo(0, 0);
			this.getOneAddress(this.id);
		}
    }
</script>

<style scoped>
.input, select{
	width:auto
}
.p20 {
    padding: 20px;
}
.border {
    background: #fff;
    border: solid 1px #dddddd;
}
.box-h4 {
    padding-bottom: 10px;
}
.left {
    float: left;
}
.clr {
    clear: both;
    font-size: 0px;
    zoom: 1;
}
.mt20 {
    margin-top: 20px;
}
.table-c-5 th {
    text-align: right;
    padding: 0 10px;
    background: #f9f9f9;
}
.table-c-5 th, .table-c-5 td {
    font-weight: normal;
    padding: 10px 3px;
    border: solid 1px #eee;
    border-width: 1px 0 1px 0;
}
.Table_1 td {
	padding: 10px 10px;
	color: #666;
}

.Table_1 tr {
	border-bottom: 1px solid #eee;
}

.Table_1 tr:hover {
	background: #e1e1e1;
}

.Table_1 tr:hover i {
	display: block;
}

.Table_1 tr.Table_1_Tr1:hover {
	background: #eee;
}

.Table_1 tr td i {
	display: none;
	font-style: normal;
	background: #ff6600 none repeat scroll 0 0;
	color: #fff;
	padding: 6px 5px;
	float: left;
	border-radius: 5px;
	cursor: pointer;
}
.Table_1 tr td i a {
	color: #fff;
	text-align: center;
	width: 105px;
}
.container_outer{
	height: 80%;
    width: 80%;
    margin-left: 10%;
    margin-top: 30px;
    padding-left: 10%;
}
.submit_button{
	padding: 5px 30px;
	border: solid 1px #bdb3b3;
}
</style>



// WEBPACK FOOTER //
// src/page/address/address.vue